import { Injectable } from '@angular/core';
import { Resolve } from '@angular/router';
import { PermissionService } from '@shared/services/session/permission.service';

@Injectable()
export class PermissionResolver implements Resolve<any> {
  public constructor(private permissionService: PermissionService) {}

  public resolve(): Promise<any> {
    return this.permissionService.getUserPermissions();
  }
}
